function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import LocaleKeys from '../../../locales/keys';
var ChangeAddressController = /*#__PURE__*/function () {
  function ChangeAddressController() {
    _classCallCheck(this, ChangeAddressController);
    this.LocaleKeys = LocaleKeys;
  }
  return _createClass(ChangeAddressController, [{
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      var _this = this;
      if (changesObj.currentAddress && Array.isArray(this.addresses)) {
        this.selectedAddress = this.addresses.find(function (address) {
          return _this.currentAddress && _this.currentAddress.Id === address.Id;
        });
      }
    }
  }, {
    key: "changeSelectedAddress",
    value: function changeSelectedAddress(addressId, addressShipToName) {
      this.selectedAddress = this.addresses.find(function (address) {
        return address.Id === addressId && address.ShipToName === addressShipToName;
      });
    }
  }, {
    key: "closeDialog",
    value: function closeDialog() {
      this.onClose()();
    }
  }, {
    key: "submitChange",
    value: function submitChange() {
      this.onSubmit()(this.selectedAddress);
    }
  }]);
}();
export default {
  template: require('./change.address.modal.html'),
  bindings: {
    addresses: '<',
    currentAddress: '<',
    onClose: '&',
    onSubmit: '&'
  },
  controller: ChangeAddressController
};